import { EmployeeEditTab } from '@/common/types';
import type { DashboardProbationReview } from '../../types';
import { DashboardSection } from '../DashboardSection';
import { ProbationReviewTable, type ProbationReviewTableProps } from './ProbationReviewTable';

interface Props {
  className?: string;
  employeeId?: string;
  loading: boolean;
  mode: ProbationReviewTableProps['mode'];
  probationReview: Array<DashboardProbationReview> | undefined;
  title: string;
}

export const ProbationReview = ({ className, employeeId, loading, mode, probationReview, title }: Props) => (
  <DashboardSection
    className={className}
    link={employeeId ? `/employees/edit/${employeeId}/${EmployeeEditTab.PROBATION_REVIEW}` : undefined}
    title={title}
  >
    <ProbationReviewTable data={probationReview ?? []} loading={loading} mode={mode} />
  </DashboardSection>
);
